import type { WidgetEntity } from 'src/entities/widget/WidgetEntity';
import { requireService } from 'src/packages/di';
import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

export function mapWidgetTemplates(
  widgets: TSerializedWidgetTemplate[],
  options?: { wellId: number | null },
): WidgetEntity[] {
  const mappedWidgets: WidgetEntity[] = [];

  widgets.forEach((widget, index) => {
    const mappedWidget = mapWidgetTemplate(widget, index, options);

    mappedWidgets.push(mappedWidget);
  });

  return mappedWidgets;
}

export function mapWidgetTemplate(
  widget: TSerializedWidgetTemplate,
  index: number,
  options?: { wellId: number | null },
): WidgetEntity {
  const mapWidgetService = requireService('widgetTemplateSerializer');

  return mapWidgetService.map(widget, index, options);
}
